import {
    clearLoggedListenerWithRedirectData,
    getLoggedForLoginWithHandler,
    getLoginWithHandlerFnData,
    getPremiumForLoginWithHandler,
    handleUserLoginWithCallbackNoPremium,
    manageLoginWithListener,
    openModalAndGotoUrl,
} from "./module_auth_helper"
import {
    doNotRedirectToProfileOnProblemSendingEmailModalClose,
    getThankyoupageUrl,
    preCheckoutActions,
} from "./module_checkout_helper"
import {
    alertNotification,
    apiCallRetry,
    checkoutLink,
    genericRetryErrMsg,
    hideSpinner,
    protectedApiCallRetry,
    sentryAPIErrorV2,
    showSpinner,
    signinModalId,
} from "./module_common"
import { AuthHelperError, LandingPageError, OfferPageError, PageFreemiumError } from "./module_errors"

// used for both 'normal' and 'redirect' flow
// subscribe, sellbook, offer pages, landing da CMS (landingOfferHybrid.js)
export async function handleUserLoginThenCheckout(userDataObj){
    const data = getLoginWithHandlerFnData()
    clearLoggedListenerWithRedirectData()

    const usrDetail = userDataObj.detail

    // for user that came from 'normal' (not signInWIthRedirect) flow and the page in not reloaded
    sessionStorage.setItem('mustReloadOnBack', location.href)

    showSpinner()

    const goToCheckout = ()=>{
        const queryString = allPlans[data.plan]['chkQueryString']
        const jwt = new URLSearchParams(queryString).get('p')
        preCheckoutActions(jwt)
        window.location.href = `${checkoutLink}${queryString}`
    }

    if (usrDetail.is_new){
        if (usrDetail.verified){
            goToCheckout()
        }
        // not verified NEW user is managed in handleEmailVerificationFlowDone
        // called after user close email-verification popup
    }else{
        if (usrDetail.verified){
            // check if it is premium
            const url = `/users/${usrDetail.user_id}/premium`
            let isPremiumResp
            try {
                isPremiumResp = await protectedApiCallRetry('GET', url, null, 3)
            } catch (error) {
                hideSpinner()
                alertNotification(genericRetryErrMsg)
                const err = new AuthHelperError("Error during premium call", {cause: error})
                const contextData = {data: usrDetail}
                sentryAPIErrorV2(err, contextData)
                return
            }
            
            if (isPremiumResp.outcome){
                if (typeof allowMultipleSubs !== 'undefined' && allowMultipleSubs == 1){
                    goToCheckout()
                }else{
                    // premium user, simply reload page
                    window.location.reload()
                }
            }else{
                goToCheckout()
            }
        }else{
            // old user, not verified. Simply refresh page
            // now user is logged and interact normally with page
            window.location.reload()
        }
    }
}

export async function handleStartFreemiumForLanding(){ 
    showSpinner()

    let url = `/users/${UIDg}/freemium_request`
    if (icAttr !== ''){
        url += '?tag='+icAttr
    }
    let freemiumResponse
    try {
        freemiumResponse = await protectedApiCallRetry('POST', url, {}, 3)
    } catch (error) {
        hideSpinner()
        alertNotification(genericRetryErrMsg)
        const err = new LandingPageError("Error during freemium call", {cause: error})
        const contextData = {data: {user_id: uid}}
        sentryAPIErrorV2(err, contextData)
        return
    }
    hideSpinner()
    let redUrl = getThankyoupageUrl()
    if (!redUrl) redUrl = "/"+LL

    window.location = redUrl
}

export const handleUserLoginLandingFreemium = handleUserLoginWithCallbackNoPremium(
    handleStartFreemiumForLanding
)

export async function handleStartFreemiumForOffer(guest = false){ 
    showSpinner()
    if (!UIDg && !guest){
        hideSpinner()
        alertNotification(genericRetryErrMsg)
        return;
    }
    const uid = guest ? guestHash.split("-")[0] : UIDg
    try {
        await postFreemiumRequest(uid, icAttr, guest ? guestHash : null)
    } catch (error) {
        hideSpinner()
        alertNotification(genericRetryErrMsg)
        const err = new OfferPageError("Error during freemium call", {cause: error})
        const contextData = {data: {user_id: uid}}
        sentryAPIErrorV2(err, contextData)
        return
    }
    hideSpinner()
    let redUrl = getThankyoupageUrl()
    if (!redUrl) redUrl = "/"+LL

    // be sure that the page after thankyoupage load the congratsGuestModal modal
    // and js call manageWelcomeGuestPremium method
    if (guest && typeof guestEmail !== 'undefined') {
        sessionStorage.setItem("showGuestCongratsModal", "ok");
        sessionStorage.setItem("guestEmail", guestEmail)
    }

    window.location = redUrl
}

export const handleUserLoginOfferFreemium = handleUserLoginWithCallbackNoPremium(
    handleStartFreemiumForOffer
)

// sparta freemium request shared by offers and pages: logged user (uid = UIDg) or guest
// (uid from the hashed email). Resolves with the raw response, throws on network/HTTP errors.
export function postFreemiumRequest(uid, tag, guestHash){
    const tagQs = tag ? 'tag=' + encodeURIComponent(tag) : ''
    if (guestHash){
        let url = `/guests/${uid}/freemium_request?uem=${encodeURIComponent(guestHash)}`
        if (tagQs) url += '&' + tagQs
        return apiCallRetry('POST', url, {}, 3)
    }
    let url = `/users/${uid}/freemium_request`
    if (tagQs) url += '?' + tagQs
    return protectedApiCallRetry('POST', url, {}, 3)
}

// pages with a 'freemium' PAGE_CONFIG: config from pageFreemium (see PageModule::freemiumScript())
let pageFreemiumCfg = null
let pageFreemiumBusy = false
// the userLogged listener is added once: every manageLoginWithListener() call adds another one
let pageFreemiumLoginArmed = false

export function setPageFreemiumConfig(cfg){
    pageFreemiumCfg = cfg
}

// every page flow ends here: the page reacts to freemium:done, an activated user
// is sent to thankyouUrl when the page declares one
function finishPageFreemium(outcome, guest){
    document.dispatchEvent(new CustomEvent('freemium:done', {detail: outcome}))
    if (outcome.status !== 'activated' || !pageFreemiumCfg || !pageFreemiumCfg.thankyouUrl){
        pageFreemiumBusy = false
        return
    }
    // busy stays set while leaving the page: no other request during navigation
    // as for the offers, the next page shows the congratsGuestModal
    if (guest) {
        sessionStorage.setItem("showGuestCongratsModal", "ok")
        sessionStorage.setItem("guestEmail", pageFreemiumCfg.guest.email)
    }
    window.location = pageFreemiumCfg.thankyouUrl
}

function freemiumOutcome(status, freemium){
    return {
        status: status,
        freemium: freemium || null,
        active: freemium ? freemium.to * 1000 > Date.now() : false,
    }
}

function emitPageFreemiumPremium(){
    finishPageFreemium(freemiumOutcome('already_premium', null), false)
}

// failed premium check after login (already reported by handleUserLoginWithCallbackNoPremium)
function emitPageFreemiumError(){
    finishPageFreemium(freemiumOutcome('error', null), false)
}

async function runPageFreemium(guest){
    if (pageFreemiumBusy) return
    pageFreemiumBusy = true
    showSpinner()
    const guestHash = guest ? pageFreemiumCfg.guest.hash : null
    const uid = guest ? guestHash.split("-")[0] : UIDg
    let outcome
    try {
        const resp = await postFreemiumRequest(uid, pageFreemiumCfg.tag, guestHash)
        if (resp && resp.done === true) {
            outcome = freemiumOutcome('activated', resp.freemium)
        } else if (resp && ['already_premium', 'already_freemium'].includes(resp.error)) {
            outcome = freemiumOutcome(resp.error, resp.freemium)
        } else {
            throw new Error('unexpected freemium response')
        }
    } catch (error) {
        const err = new PageFreemiumError("Error during page freemium call", {cause: error})
        sentryAPIErrorV2(err, {data: {user_id: uid, guest: guest}})
        outcome = freemiumOutcome('error', null)
    }
    hideSpinner()
    // finishPageFreemium() releases the busy flag unless the user is redirected
    finishPageFreemium(outcome, guest)
}

export const handleUserLoginPageFreemium = handleUserLoginWithCallbackNoPremium(
    () => runPageFreemium(false),
    emitPageFreemiumPremium,
    emitPageFreemiumError
)

// window.doFreemium() on pages: same cases as manageBuyButtonClickFreemiumOffer (offer.js)
export function startPageFreemium(){
    if (!pageFreemiumCfg) {
        sentryAPIErrorV2(new PageFreemiumError("doFreemium called without pageFreemium"), {})
        return
    }
    if (getLoggedForLoginWithHandler()){
        if (getPremiumForLoginWithHandler()){
            emitPageFreemiumPremium()
        }else{
            runPageFreemium(false)
        }
        return
    }
    if (pageFreemiumCfg.guest){
        runPageFreemium(true)
        return
    }
    if (pageFreemiumLoginArmed){
        // modal closed and CTA clicked again: just reopen it
        openModalAndGotoUrl(signinModalId)
        return
    }
    pageFreemiumLoginArmed = true
    doNotRedirectToProfileOnProblemSendingEmailModalClose()
    // label registered in postLoginWithRedirectFuncions (module_common.js), not imported
    // from there to avoid a circular dependency
    manageLoginWithListener(
        handleUserLoginPageFreemium,
        'handleUserLoginForFreemiumPage',
        null,
        null
    )
}